<template>
  <div class="flow">
    <EditorToolbar v-if="!isConfigurator" :formName="formName" />
    <ConfiguratorToolbar v-if="isConfigurator && currentForm" :form="currentForm" />
    <router-view />
  </div>
</template>

<script>
  import { watchEffect, computed } from 'vue';
  import { useRoute } from 'vue-router';
  import { useFormStore } from '@/store/formStore';
  import EditorToolbar from '@/components/editor/EditorToolbar.vue';
  import ConfiguratorToolbar from '@/components/configurator/ConfiguratorToolbar.vue';

  export default {
    components: { EditorToolbar, ConfiguratorToolbar },
    setup() {
      const route = useRoute();
      const formStore = useFormStore();

      watchEffect(() => {
        if (route.params.id) {
          formStore.loadForm(route.params.id);
        }
      });

      const formName = computed(() => (formStore.currentForm ? formStore.currentForm.name : ''));
      const currentForm = computed(() => formStore.currentForm);
      const isConfigurator = computed(() => {
        return currentForm.value?.type === 'configurator';
      });

      return {
        formName,
        currentForm,
        isConfigurator,
      };
    },
  };
</script>

<style scoped lang="scss">
  .flow {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    min-height: 0;
    // overflow: hidden;
  }
</style>
